var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"multi-img",attrs:{"src":_vm.src,"alt":_vm.name},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }